import axios from "../axios";
const handleLoginApi = (email, password) => {
    // console.log("hello from HandleLoginApi");
    return axios.post('/api/login', { email, password }); // nhu nay nghia "email: email input", "password: password input" de khop voi Product.email ben Nodejs
}
const getAllProducts = (inputid) => {
    // su dung cu phap cua template string
    return axios.get(`/api/get-all-products?id=${inputid}`);
    // return axios.get('/api/get-all-Product', {
    //     data: {
    //         id: inputid
    //     }
    // });

}
const createNewProductService = (data) => {
    // console.log("hello from createNewProduct Service:", DataTransfer);
    return axios.post('/api/create-new-product', data)
}
const deleteProductService = (data) => {
    // console.log("hello from createNewProduct Service:", DataTransfer);
    // return axios.delete('/api/delete-product', data)
    return axios.delete('/api/delete-Product', {
        data: {
            id: data.id
        }
    });
}
const editProductService = (data) => {
    // console.log("hello from editProductService Service:", data.id);
    return axios.put('/api/edit-product', data);

}
export {
    handleLoginApi,
    getAllProducts,
    createNewProductService,
    deleteProductService,
    editProductService
}